// extracted by mini-css-extract-plugin
module.exports = {"clickable":"Clickable_clickable__lEuDw","text":"Clickable_text__fjwJj","icon":"Clickable_icon__ooSCU","fade_in":"Clickable_fade_in__pbmlB"};